import { ActionIcon, CopyButton, Group, Paper, PaperProps, rem, ScrollArea, ScrollAreaProps, Text, Tooltip } from "@mantine/core";
import { IconCopy } from "@tabler/icons-react";

export function CopyText(props: { text: string, paperProps?: PaperProps, scrollArea?: ScrollAreaProps }) {
    return <Paper px={16} pt={10} shadow="none" bg="var(--mantine-primary-color-light)" {...props.paperProps}>
        <Group p={0} gap={0}>
            <ScrollArea scrollbarSize={10} offsetScrollbars flex={1} scrollbars="x" {...props.scrollArea}>
                <Text style={{whiteSpace:"pre-wrap"}}>
                    {props.text}
                </Text>
            </ScrollArea>
            <CopyButton value={props.text}>
                {({ copied, copy }) => (
                    <Tooltip label={copied ? '已複製' : ''} disabled={!copied} withArrow>
                        <ActionIcon size={42} pb={10} variant="transparent" onClick={copy}>
                            <IconCopy style={{ width: rem(24), height: rem(24) }} />
                        </ActionIcon>
                    </Tooltip>
                )}
            </CopyButton>
        </Group>
    </Paper>
}